import styled from 'styled-components'

export default styled.input<{
  error?: boolean
  rounded?: boolean
}>`
  width: 100%;
  padding: 18px;
  margin: 8px 0 8px;
  outline: 0;
  text-overflow: ellipsis;
  border: 1px solid
    ${({ theme, error }) =>
      error ? theme?.['-ds-error-300']?.value : theme.colors.textGreyLight};

  &:focus {
    border-color: ${({ theme }) => theme.brand.jungle};
  }

  ${({ rounded = true }) =>
    rounded &&
    `
    border-radius: 6px;
  `}
`
